import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';
import axios from 'axios';
import VueMoment from 'vue-moment';
import VueSignaturePad from 'vue-signature-pad';

// === DEBUG de rutas/recursos en producción ===
// === DEBUG de rutas/recursos en producción ===
function traceEnabled() {
  let traceQuery = false;
  try {
    const q = new URLSearchParams(window.location.search);
    traceQuery = q.get('trace') === '1';
  } catch (e) {
    // Fallback si URLSearchParams no está disponible
    traceQuery = /[?&]trace=1(?:&|$)/.test(window.location.search);
  }
  return traceQuery || localStorage.getItem('DEBUG_ROUTES') === '1';
}


if (traceEnabled()) {
  window.__TRACE_ON__ = true;
  console.info('[TRACE] boot main.js — NODE_ENV:', process.env.NODE_ENV, 'BASE_URL:', process.env.BASE_URL);

  // Detecta fallos al cargar chunks (imports dinámicos de componentes/rutas)
  window.addEventListener('error', (e) => {
    const msg = e?.message || '';
    if (/ChunkLoadError|Loading chunk \d+ failed/i.test(msg)) {
      console.error('[TRACE] Chunk load error:', msg, e);
    }
  });

  window.addEventListener('unhandledrejection', (e) => {
    const msg = e?.reason?.message || String(e?.reason || '');
    if (/ChunkLoadError|Loading chunk \d+ failed/i.test(msg)) {
      console.error('[TRACE] Unhandled chunk load error:', msg, e?.reason);
    }
  });

  // helpers rápidos desde consola
  window.enableRouteTrace = () => { localStorage.setItem('DEBUG_ROUTES','1'); location.reload(); };
  window.disableRouteTrace = () => { localStorage.removeItem('DEBUG_ROUTES'); location.reload(); };
}

Vue.prototype.$http = axios

// Localization
import i18n from './utilities/locale/i18n';

// Main style sheet
require('./assets/css/style.css');

// Signature Pad
Vue.use(VueSignaturePad);

Vue.config.productionTip = false

new Vue({
  i18n,
  store,
  router,
  vuetify,
  VueMoment,
  render: h => h(App)
}).$mount('#app');

Vue.directive('pdf-app-load', {
  bind: function (el) {
    let zoomCount = 0;
    const zoomIn = el.querySelector('#zoomIn')
    const zoomOut = el.querySelector('#zoomOut')
    const viewerContainer = el.querySelector('#mainContainer #viewerContainer')

    markNoZoom(zoomCount)
    zoomIn.addEventListener('click', () => {
      zoomCount++
      markNoZoom(zoomCount)
    })
    zoomOut.addEventListener('click', () => {
      zoomCount--
      markNoZoom(zoomCount)
    })

    function markNoZoom (count) {
      if(count == 0) {
        viewerContainer.classList.add('no-zoom');
      } else {
        viewerContainer.classList.remove('no-zoom');
      }
    }
  }
})

Vue.directive('uppercase', {
	update (el) {
		el.value = el.value.toUpperCase()
	},
})